import { createIcon } from "@chakra-ui/react";

export const Challenging = createIcon({
  displayName: "Challenging",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#xucecs0foa)">
      <path
        fill="currentColor"
        d="M12 3.063a8.938 8.938 0 1 0 0 17.875 8.938 8.938 0 0 0 0-17.875zM23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0zm-15.795-.688a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0zm8.25-1.374a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75zm-7.58 6.187c0-.572.46-1.031 1.031-1.031h6.188c.571 0 1.031.46 1.031 1.031 0 .572-.46 1.031-1.031 1.031H8.906c-.571 0-1.031-.46-1.031-1.031zm7.253-9.032L13.86 8.361a.69.69 0 0 1-.97 0 .69.69 0 0 1 0-.972l1.267-1.267a2.406 2.406 0 0 1 3.704.365l.21.318a.69.69 0 0 1-.189.954.69.69 0 0 1-.954-.19l-.21-.317a1.03 1.03 0 0 0-1.586-.159h-.004zM6.5 7.188h2.75a.69.69 0 0 1 .688.687.69.69 0 0 1-.688.688H6.5a.69.69 0 0 1-.688-.688.69.69 0 0 1 .688-.688z"
      />
    </g>,
    <defs>
      <clipPath id="xucecs0foa">
        <path fill="#fff" transform="translate(1 1)" d="M0 0h22v22H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "Confused face"
  }
});

export default Challenging;
